import React from "react";
import Text from "common/Typography/Text";
import Link from "common/Typography/Link";
import styled, { css } from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens";
import { ResendEmailProps } from "@shared/features/onboarding/types";
import { SUPPORT_BOT_LINK } from "@shared/common/constants";
import { useBranding } from "@shared/utils/hooks/useBranding.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const ResendEmailInstructions = ({ isVerify, addBorder }: ResendEmailProps) => {
  const { isWhitelabel } = useBranding();
  const { t } = useTypedTranslation(LanguageNameSpaces.AUTH);
  const emailTypeText = isVerify
    ? t("resend_email.code")
    : t("resend_email.instructions");

  return (
    <Wrapper $addBorder={addBorder}>
      <Text>
        {t("resend_email.description", { emailType: emailTypeText })}
        {isWhitelabel ? "" : ` ${t("resend_email.contact_support")} `}
        {!isWhitelabel && (
          <Link href={SUPPORT_BOT_LINK} target="_blank">
            {t("resend_email.cornix_support")}
          </Link>
        )}
      </Text>
    </Wrapper>
  );
};

export default ResendEmailInstructions;

const Wrapper = styled.div<{ $addBorder?: boolean }>`
  width: 100%;
  margin-top: 20px;
  ${(p) =>
    p.$addBorder &&
    `
    border-top: ${p.theme.borders.medium};
    padding-top: 20px;
  `};
  ${(p) =>
    p.theme.isNewLook &&
    css`
      margin-top: 16px;
      text-align: center;
      ${p.$addBorder &&
      css`
        border-top: 1px solid ${p.theme.colors.cardBorderColor};
        padding-top: 16px;
      `}
      &, span, a {
        ${newLookType.meta};
      }
      > span {
        color: ${getNewLookTokens(p.theme).muted};
      }
    `}
`;
